// Color helpers shared across drawing, scoring, save, and palette UI.
// All hex inputs are expected to be 6-digit `#rrggbb` (no shorthand,
// no alpha) — that's what the palette stores and what the eyedropper
// emits, so callers don't have to defensively normalize.

export function hexToRgb(hex) {
  const m = hex.replace("#", "");
  return {
    r: parseInt(m.slice(0, 2), 16),
    g: parseInt(m.slice(2, 4), 16),
    b: parseInt(m.slice(4, 6), 16),
  };
}

export function rgbToHex(r, g, b) {
  const h = (n) => Math.max(0, Math.min(255, n | 0)).toString(16).padStart(2, "0");
  return `#${h(r)}${h(g)}${h(b)}`;
}

// Rec. 601 luma. Used by ColorPalette to flip the swatch number's color
// against a light vs dark fill so the digit always reads.
export function isLightColor(hex) {
  const m = hex.replace("#", "");
  if (m.length !== 6) return false;
  const r = parseInt(m.slice(0, 2), 16);
  const g = parseInt(m.slice(2, 4), 16);
  const b = parseInt(m.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 160;
}
